module.exports = __webpack_public_path__ + "static/media/house.9ad6d6ad.svg";